var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrabIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14062 2.04625C4.14062 1.15938 3.37063 0.4375 2.42188 0.4375C1.47312 0.4375 0.703125 1.15938 0.703125 2.04625C0.703125 2.9345 1.47312 3.655 2.42188 3.655C3.37063 3.655 4.14062 2.9345 4.14062 2.04625ZM4.14062 13.9537C4.14062 13.0655 3.37063 12.345 2.42188 12.345C1.47312 12.345 0.703125 13.0655 0.703125 13.9537C0.703125 14.8406 1.47312 15.5625 2.42188 15.5625C3.37063 15.5625 4.14062 14.8406 4.14062 13.9537ZM2.42188 6.39125C3.37063 6.39125 4.14062 7.11312 4.14062 8C4.14062 8.88688 3.37063 9.60875 2.42188 9.60875C1.47312 9.60875 0.703125 8.88688 0.703125 8C0.703125 7.11312 1.47312 6.39125 2.42188 6.39125ZM9.29688 2.04625C9.29688 1.15938 8.52688 0.4375 7.57812 0.4375C6.62937 0.4375 5.85938 1.15938 5.85938 2.04625C5.85938 2.9345 6.62937 3.655 7.57812 3.655C8.52688 3.655 9.29688 2.9345 9.29688 2.04625ZM7.57812 12.345C8.52688 12.345 9.29688 13.0655 9.29688 13.9537C9.29688 14.8406 8.52688 15.5625 7.57812 15.5625C6.62937 15.5625 5.85938 14.8406 5.85938 13.9537C5.85938 13.0655 6.62937 12.345 7.57812 12.345ZM9.29688 8C9.29688 7.11312 8.52688 6.39125 7.57812 6.39125C6.62937 6.39125 5.85938 7.11312 5.85938 8C5.85938 8.88688 6.62937 9.60875 7.57812 9.60875C8.52688 9.60875 9.29688 8.88688 9.29688 8Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrabIcon);
export default __webpack_public_path__ + "static/media/grabIcon.b4c0735cf1458e290bec351cf417c1a9.svg";
export { ForwardRef as ReactComponent };